<template>
	<li class="c-checklist-filter__item menu-item" :key="text">
		<label class="c-checklist-filter__label">
			<input
				class="c-checklist-filter__input"
				:type="type"
				:name="'checklist-filter-radio'"
				:value="value"
				:encodedName="encodedName"
				:checked="active"
				@change="onRadioChange"
			/>
			<span
				class="c-checklist-filter__text"
				:style="{ display: type === 'hidden' ? 'none' : '' }"
				>{{ text }}</span
			>
		</label>
	</li>
</template>

<script>
import VuexStore from "../../js/vuex-store/vuex-store.js";

export default {
	name: "VChecklistFilterRadio",

	props: {
		encodedName: {
			type: String
		},
		value: {
			type: String
		},
		type: {
			type: String,
			default: "radio"
		},
		text: {
			type: String
		},
		index: {
			type: Number
		},
		className: {
			type: String
		},
		active: {
			type: Boolean
		}
	},

	methods: {
		onRadioChange(event) {
			const url = `?checklistid=${event.target.value}`;
			window.location.href = url;
		}
	},
	created() {
		if (this.active) {
			VuexStore.commit(
				"checklist/setChecklistType",
				String(this.encodedName)
			);
		}
	}
};
</script>
